import React, {Component} from 'react';
import $ from "jquery";
import validator from 'validator';
import axios from 'axios';
import Data from './Data';
import AES128 from './AES128';

class LoginAdmin extends Component {

    constructor(props){
        super(props);

        this.state = {
            messageid: '',
            fields : {
                username : '',
                password : '',
                code : ''
            },
            errors : {

            }
        }
    }

    componentDidMount() {
        if (this.props.auth) {
            window.location.pathname = '/';

        }
        document.title = "ورود - پنل مدیریت";
    }

    handleSubmit(event){
        event.preventDefault();

        this.handleValidation((valid)=>{
            if (valid) this.handleRequest();
        })

    }

    goToVeryfy(messageid){


        this.setState({
            messageid: messageid
        });

        $('#progressTop').addClass('invisible');
        $('#userpass').addClass('novisible');
        $('#code').removeClass('novisible');

    }

    handleRequest(){
        $('#waitspinner').modal('show');
        const {username, password} = this.state.fields;
        let { fields } = this.state;
        let errors = {};

        let data = new FormData();
        data.append('username',username);
        data.append('password',password);

        axios.post(Data.server+'login.php',data)
        .then(response=>{
            $('#waitspinner').modal('hide');

            console.log(response.data);
            if (response.data === "wrong") {

                errors['username'] = 'نام کاربری اشتباه است';
                errors['password'] = 'رمز عبور اشتباه است';
                this.setState({errors});
    
            }else{
                try {

                    let json = JSON.parse(JSON.stringify(response.data));

                    let result = json["return"];
                    let output = json["entries"][0];

                    let status = result["status"];

                    if (status === 200) {

                        let messageid = output["messageid"];

                        this.goToVeryfy(messageid);

                    } else {

                        $('#progressTop').addClass('invisible');
                        $('#r_fab').removeClass('invisible');
                        this.props.enqueueSnackbar("خطای "+status+" رخ داد", {
                            variant: 'error',
                        });
                    }

                } catch (e) {
                    $('#progressTop').addClass('invisible');
                    $('#r_fab').removeClass('invisible');
                    console.log(e);
                    this.props.enqueueSnackbar("خطا : "+e.toString(), {
                        variant: 'error',
                    });
                }

            }
            

        })
        .catch(error=>{
            $('#progressTop').addClass('invisible');
            $('#r_fab').addClass('animate__animated animate__zoomIn');
            console.log(error);
        });


    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        if (validator.isEmpty(fields.username)){
            formIsValid = false;
            errors['username'] = 'لطفا نام کاربری را وارد کنید!';
        }

        if (validator.isEmpty(fields.password)){
            formIsValid = false;
            errors['password'] = 'لطفا گذرواژه را وارد کنید!';
        }

        this.setState({errors}, ()=>{
            return callback(formIsValid)
        });
    }

    handleChange(event){
        let fields = this.state.fields;
        let target = event.target;
        fields[target.name] = target.value;
        this.setState({fields});
    }
    handleSubmit2(event){
        event.preventDefault();

        this.handleValidation2((valid)=>{
            if (valid){
                this.handleRequest2();
            }
        })

    }
    handleValidation2(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        if (fields.code === ""){
            formIsValid = false;
            errors['code'] = 'لطفا کد فعالسازی را وارد کنید!';
        }
        if (fields.code.length < 5){
            formIsValid = false;
            errors['code'] = 'لطفا کد فعالسازی را کامل وارد کنید!';
        }


        this.setState({errors}, ()=>{
            return callback(formIsValid)
        });
    }
    handleRequest2(){
        $('#waitspinner').modal('show');
        $('#progressTop').removeClass('invisible');

        const {code,username,password} = this.state.fields;
        const {messageid} = this.state;

        let data = new FormData();
        data.append('messageid', messageid);
        data.append('username', username);
        data.append('password', password);
        data.append('verify_code', code);

        axios.post(Data.server+'checkCode.php',data)
            .then(response=>{

                let res = response.data;
                $('#waitspinner').modal('hide');
                $('#progressTop').addClass('invisible');

                console.log(res);
                if (res === 'wrong messageid'){

                    this.props.enqueueSnackbar("خطا : شناسه پیامک با شماره تلفن مرتبط نیست", {
                        variant: 'error',
                    });
                }
                if (res === 'timeout'){

                    this.props.enqueueSnackbar("این کد فعالسازی , منقضی شده\nلطفا مجددا درخواست کد فعالسازی کنید", {
                        variant: 'error',
                    });
                }
                if (res.hasOwnProperty("token")){
                    let token2 = res['token'];
                    localStorage.setItem('admintoken',token2);
                         this.props.login();
                        window.location.href = '/';
                
                }
                
                if (res === 'wrong code'){
                    this.props.enqueueSnackbar("کد فعالسازی اشتباه است", {
                        variant: 'error',
                    });
                }


            })
            .catch(error=>{
                $('#v_fab').removeClass('invisible');
                $('#progressTop').addClass('invisible');
                this.props.enqueueSnackbar("خطا : مشکلی در اتصال به سرور پیش آمد", {
                    variant: 'error',
                    action: (
                        <i className="material-icons">
                            close
                        </i>
                    ),
                });

                console.log(error);
            });
    }

    render() {

        const {username , password , code} = this.state.fields;
        const {errors} = this.state;
        return (
            <div className="container">
                
            <div id="userpass" className="">
                <h2 className="text-center mt-3">ورود</h2>
                <form onSubmit={this.handleSubmit.bind(this)} className="login-form mx-auto mt-3">
                    <div className="form-group text-right">
                        <label>نام کاربری</label>
                        <input
                            type="text"
                            className={["form-control", errors['username'] ? 'is-invalid':'is-valid'].join(' ')}
                            name="username"
                            value={username}
                            onChange={this.handleChange.bind(this)}
                            placeholder="لطفا یک نام کاربری وارد کنید"/>
                        <span className="invalid-feedback rtl" style={{display : errors['username'] ? 'block':'none'}}>{errors['username']}</span>
                    </div>
                    <div className="form-group text-right">
                        <label>گذرواژه</label>
                        <input
                            type="password"
                            className={["form-control", errors['password'] ? 'is-invalid':'is-valid'].join(' ')}
                            name="password"
                            value={password}
                            onChange={this.handleChange.bind(this)}
                            placeholder="لطفا گذرواژه را وارد کنید"/>
                        <span className="invalid-feedback rtl" style={{display : errors['password'] ? 'block':'none'}}>{errors['password']}</span>

                    </div>
                    <div className="form-group text-center">
                        <button type="submit" className="btn btn-success btn-block">ورود</button>
                    </div>


                </form>

            </div>
                

            <div id="code" className="novisible">
                <h2 className="text-center mt-3">اعتبارسنجی</h2>
                <form onSubmit={this.handleSubmit2.bind(this)} className="login-form mx-auto mt-3">
                    <div className="form-group text-right">
                        <label>کد فعالسازی</label>
                        <input
                            type="number"
                            className={["form-control", errors['code'] ? 'is-invalid':'is-valid'].join(' ')}
                            name="code"
                            value={code}
                            onChange={this.handleChange.bind(this)}
                            placeholder="لطفا کد فعالسازی را وارد کنید"/>
                        <span className="invalid-feedback rtl" style={{display : errors['code'] ? 'block':'none'}}>{errors['username']}</span>
                    </div>
                    
                    <div className="form-group text-center">
                        <button type="submit" className="btn btn-success btn-block">ورود</button>
                    </div>


                </form>
            </div>
                
            </div>
        );
    }
}



export default LoginAdmin;
